import { getNewsletterArchiveSSP } from '../lib/getServerSideProps';
import PageComponent from '../components/Page';
import NewsletterArchive from '../components/NewsletterArchive';
import CTA from '../components/CTA';

const Newsletter = ({ newsletterArchive, ...props }) => {
  return (
    <PageComponent prepend={true} cta={false} {...props}>
      <CTA {...props.page.data} />
      <section className="mb-5 border-bottom">
        <div className="container pb-5">
          <div className="row">
            <div className="col-lg-10 col-12">
              <NewsletterArchive list={newsletterArchive} />
            </div>
          </div>
        </div>
      </section>
    </PageComponent>
  );
};

export default Newsletter;

const _getServerSideProps = getNewsletterArchiveSSP();

export async function getServerSideProps({ locale, previewData }) {
  return _getServerSideProps({
    params: { uid: 'newsletter' },
    locale,
    previewData
  });
}
